<template>
    <!-- 今日供应链统计 -->
    <div>
        <!-- 头部-->
        <div class="city-child-head">
            <!-- 标题 -->
            <div class="city-child-head-left float-l">
                <div class="city-child-head-icon"></div>
                <span>今日供应链统计</span>
            </div>
        </div>
        <!-- 内容 -->
        <div class="city-content city-content-chunk-box">
            <!-- 内容 -->
            <div class="city-box">
                <div class="content-item" v-for="(item, index) in pageList" :key="index">
                    <div class="content-item-left">
                        <svg-icon class="bg-svg" :icon-file-name="item.icon" />
                    </div>
                    <div>
                        <div class="t-title">{{ item.title }}</div>
                        <div class="t-text">{{ item.data }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getSupplyChain } from '../../api/holdMy';
export default {

    data() {
        return {
            refreshImgIng: null,   // 刷新定时器
            getData: {
                cityName: this.$route.query.cityName,
                city: this.$route.query.cityName,
            },
            pageList: [{
                title: '加油（金额/升）',
                icon: 'u52',
                data: '0/0'
            }, {
                title: '维修（金额/次数）',
                icon: 'u43',
                data: '0/0'
            }, {
                title: '台班（金额/小时）',
                icon: 'u264',
                data: '0'
            }]
        }
    },
    components: {},
    created() {
        this.refreshScale();
    },
    mounted() {
    },
    beforeDestroy() {
        clearInterval(this.refreshImgIng);
    },
    methods: {
        // 刷新数据
        refreshScale() {
            this.getSupplyChain();
            this.refreshImgIng = setInterval(() => {
                this.getSupplyChain();
            }, 1000 * 60 * 30)
        },
        getSupplyChain() {
            getSupplyChain({ ...this.getData }).then(res => {
                if (res.result == 0) {
                    this.pageList[0].data = `${res.userdata.todayOilFee || 0}/${res.userdata.todayOilVolume || 0}`;
                    this.pageList[1].data = `${res.userdata.todayMaintenanceFee || 0}/${res.userdata.todayMaintenanceCount || 0}`;
                    this.pageList[2].data = res.userdata.todayHours || 0;
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.city-content {
    height: 258px;

    .city-box {
        padding: 0 8px;

        .content-item {
            display: flex;
            align-content: center;
            justify-content: left;
            font-family: '微软雅黑', sans-serif;
            font-weight: 400;
            font-style: normal;
            color: #FFFFFF;
            font-size: 16px;
            margin: 22px 0;

            &-left {
                position: relative;
                margin-right: 5px;
            }

            .t-title {
                font-size: 13px;
                font-weight: 400;
                line-height: 19px;
                margin-bottom: 4px;
            }

            .t-text {
                font-size: 20px;
                font-weight: 500;
                line-height: 29px;
            }
        }
    }

    .svg-file2 {
        position: absolute;
        top: 7%;
        left: 8%;
    }

    .svg-file {
        position: absolute;
        top: 7%;
        left: 8%;
    }

    .bg-svg {
        display: block;
        width: 58px;
        height: 58px;
    }

    @keyframes rotation {
        0% {
            -webkit-transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(360deg);
        }
    }
}
</style>